import nameLists from './NameLists.json'
import texts from '../_joomlaExports/language_map.json'

function getLangMetaList(region) {
  const names = nameLists[region]
  return names.map((name) => {
    const itemName = texts.find((item) => item['en-us'] === name)
    const itemContent = texts.find((item) => item.id === itemName.id + 1)
    return {
      Name: name,
      // @ts-ignore
      Id: itemName.id,
      NameTranslations: itemName,
      TextTranslations: itemContent
    }
  })
}

function getRegionTranslations(region) {
  const item = texts.find((item) => item['en-us'] === region)
  return item
}

// {
//   Name: 'Arabic / Asian',
//   Code: 'ArabicAsian',
//   Languages: [
//     {
//       Name: 'Dari',
//       Code: 'prs',
//       Locale: 'fa-AF',
//       Image: 'dari',
//       Id: 587
//     },
//     {
//       Name: 'Persian',
//       Code: 'fas',
//       Locale: 'fa-IR',
//       Image: 'persian',
//       Id: 481
//     }
//   ]
// }

export default [
  {
    Name: 'European',
    Code: 'European',
    NameTranslations: getRegionTranslations('European'),
    Languages: getLangMetaList('European')
  },
  {
    Name: 'Arabic / Asian',
    Code: 'ArabicAsian',
    NameTranslations: getRegionTranslations('Arabic / Asian'),
    Languages: getLangMetaList('ArabicAsian')
  },
  {
    Name: 'American',
    Code: 'American',
    NameTranslations: getRegionTranslations('American'),
    Languages: getLangMetaList('American')
  },
  {
    Name: 'African',
    Code: 'African',
    NameTranslations: getRegionTranslations('African'),
    Languages: getLangMetaList('African')
  }
]
